
export const translations = {
  zh: {
    appName: "石头大人",
    appSub: "Stone Master AI",
    history: "记录本",
    slogan: "走过山河，读懂沉默",
    sloganSub: "人人都是石头大人",
    heroDesc: "拍摄岩石、矿物晶体或化石样本，即刻获取地质级专业鉴定。",
    uploadTitle: "上传岩石照片",
    uploadSubtitle: "点击区域或拖拽上传",
    album: "相册",
    camera: "拍照",
    processing: "正在优化岩石样本图像...",
    analyzing: "石头大人正在通过放大镜观察...",
    reset: "鉴定新样本",
    saveShare: "保存 / 分享证书",
    generating: "正在生成...",
    reportTitle: "岩石鉴定报告",
    reportNo: "报告编号",
    resultTitle: "鉴定结果",
    category: "分类",
    interpretation: "成因",
    geoContext: "地质背景",
    alternative: "替代方案",
    diff: "区别",
    techData: "技术参数",
    grain: "颗粒",
    structure: "构造",
    hardness: "硬度",
    weathering: "风化",
    minerals: "矿物",
    metamorphism: "变质",
    colorOrigin: "成色",
    alteration: "蚀变",
    economicTitle: "经济地质与找矿潜力",
    alterationMap: "围岩蚀变",
    indicators: "指示矿物",
    structuralControl: "构造控矿",
    potential: "找矿潜力评价",
    microTitleHand: "虚拟光薄片",
    microTitleThin: "虚拟手标本",
    inferenceLabelHand: "宏微映射",
    inferenceLabelThin: "逆向推理",
    expertEval: "专家评估",
    verified: "官方验证",
    disclaimerTitle: "免责声明",
    disclaimer: "本应用（石头大人）使用人工智能技术分析图像特征，鉴定结果基于视觉信息推断，仅供地质爱好者学习与参考。AI 鉴定受环境光线、拍摄角度及矿物细微特征限制，结果可能存在误差。对于涉及贵重宝石交易、矿权判定等严谨场景，请务必以专业地质实验室的实物检测报告为准。",
    historyTitle: "野外记录本",
    historySub: "Digital Field Notebook",
    historyEmpty: "暂无鉴定记录",
    historyEmptySub: "快去探索第一块石头吧！",
    clearHistory: "撕掉所有记录",
    feature1Title: "全岩石大类 专家引擎",
    feature1Desc: "深度集成岩浆岩、沉积岩、变质岩及特殊矿物判据。涵盖从陆源碎屑到高压变质的完整逻辑体系。",
    feature2Title: "地质专家级 深度解析",
    feature2Desc: "不止于分类，更能洞察细节。深度解析矿物组合、颗粒边界、构造特征，揭示地球演变密码。",
    feature3Title: "专业标准化 鉴定证书",
    feature3Desc: "生成包含岩石分类、成分、成因及地质背景的标准化专家报告。支持高清保存与社交分享。",
    errorTitle: "鉴定中断",
    errorGeneric: "鉴定服务暂时不可用，请稍后重试。",
    heicError: "HEIC 图片转换失败，请尝试使用 JPG 或 PNG 格式。",
    saveTipTitle: "如何保存到相册？",
    saveTipDesc: "由于系统安全限制，请长按下方图片，在弹出的菜单中选择“存储图像”或“发送给朋友”。",
    copyImage: "复制图片",
    copied: "已复制",
    downloadFile: "下载文件",
    thinTag: "薄片",
    potentialTag: "有潜力",
    multiUploadTitle: "多图综合鉴定",
    multiUploadDesc: "支持上传 PPL/XPL (薄片) 或 宏观/微观 (手标本) 组合，提升鉴定准确度。",
    addMore: "添加更多图片",
    analyzeNow: "开始综合鉴定",
    pplLabel: "单偏光 (PPL)",
    xplLabel: "正交偏光 (XPL)",
    macroLabel: "宏观全景",
    microLabel: "局部细节",
    imageCount: "张图片",
    guideTitle: "鉴定专家建议",
    guideHand: "📸 手标本：上传一张“全景图”和一张“微距细节图”，AI 将进行宏微映射分析。",
    guideThin: "🔬 显微薄片：上传同一视域的“单偏光(PPL)”和“正交偏光(XPL)”，AI 将启动光性矿物学侦探模式。",
    expertFeedback: "专家纠偏",
    feedbackTitle: "提交专家修正建议",
    feedbackCorrectName: "正确岩石名称",
    feedbackReason: "修正理由 (如：观察到特征 X，而非 Y)",
    feedbackSubmit: "提交修正",
    feedbackSuccess: "感谢您的反馈！我们将以此校准知识库。",
    distillTitle: "案例提炼助手",
    distillDesc: "将野外发现转化为标准化的鉴定判据 (Case Rules)。",
    distillPrompt: "请根据此案例提炼出一条核心鉴定准则...",
    limitReached: "鉴定额度已用完",
    limitReachedSub: "请补充鉴定额度以继续使用石头大人。",
    upgradePro: "获取专业额度",
    remainingTries: "今日剩余免费次数",
    unlimited: "无限次",
    proActive: "专业版已激活",
    enterCode: "输入激活码",
    redeem: "激活",
    redeemSuccess: "激活成功！额度已更新。",
    invalidCode: "无效的激活码，请重新输入。",
    buyPro: "扫码支付 30 元获取 100 次鉴定额度",
    orderRemark: "支付成功后，请在支付宝留言中留意我们发放的激活码",
    contactSupport: "联系客服获取激活码",
    creditsRemaining: "剩余鉴定额度",
    confidence: "置信度",
    diagnosticTitle: "交互式诊断面板",
    diagnosticSub: "为了提高鉴定准确度，请根据以下建议进行实地物理测试并反馈结果。",
    testResult: "测试结果反馈",
    diagnosticReady: "诊断信息已就绪，可以进行二次校准",
    diagnosticPending: "请完成所有建议的物理测试",
    submitDiagnostic: "提交测试结果并重新校准",
    macroAppearance: "宏观外观",
    macroStructure: "构造特征",
    fossilTitle: "古生物化石档案",
    fossilType: "化石类型",
    genusSpecies: "属种建议",
    geologicalAge: "地质年代",
    preservation: "保存状态",
    environment: "环境推断",
    fossilDesc: "化石描述"
  },
  en: {
    appName: "Stone Master",
    appSub: "Stone Master AI",
    history: "Notebook",
    slogan: "Read the silence of mountains",
    sloganSub: "Everyone is a Stone Master",
    heroDesc: "Capture rocks, minerals, or fossils for instant professional geological identification.",
    uploadTitle: "Upload Rock Photo",
    uploadSubtitle: "Click or drag to upload",
    album: "Gallery",
    camera: "Camera",
    processing: "Optimizing rock sample image...",
    analyzing: "Stone Master is observing through a loupe...",
    reset: "New Sample",
    saveShare: "Save / Share Report",
    generating: "Generating...",
    reportTitle: "Geological Report",
    reportNo: "Report No.",
    resultTitle: "Identification",
    category: "Category",
    interpretation: "Formation",
    geoContext: "Geology Context",
    alternative: "Alternative",
    diff: "Difference",
    techData: "Technical Data",
    grain: "Grain",
    structure: "Structure",
    hardness: "Hardness",
    weathering: "Weathering",
    minerals: "Minerals",
    metamorphism: "Metamorphism",
    colorOrigin: "Color Cause",
    alteration: "Alteration",
    economicTitle: "Economic & Prospecting",
    alterationMap: "Alteration Mapping",
    indicators: "Indicator Minerals",
    structuralControl: "Structural Control",
    potential: "Prospecting Potential",
    microTitleHand: "Virtual Thin Section",
    microTitleThin: "Virtual Hand Specimen",
    inferenceLabelHand: "Macro → Micro Mapping",
    inferenceLabelThin: "Micro → Macro Inference",
    expertEval: "Expert Evaluation",
    verified: "VERIFIED",
    disclaimerTitle: "Disclaimer",
    disclaimer: "This app (Stone Master) uses AI to analyze geological features based on visual data. Results are for educational purposes. AI identification may be affected by lighting and angles. For commercial valuation or legal mining claims, please consult a certified geological laboratory.",
    historyTitle: "Field Notebook",
    historySub: "Digital Field Notebook",
    historyEmpty: "No Records Yet",
    historyEmptySub: "Go explore your first rock!",
    clearHistory: "Clear All Records",
    feature1Title: "Expert Rock Engine",
    feature1Desc: "Integrated criteria for Igneous, Sedimentary, and Metamorphic rocks. Covering systems from clastic to high-pressure metamorphism.",
    feature2Title: "Professional Analysis",
    feature2Desc: "Deep analysis of mineral assemblages, grain boundaries, and structures to reveal geological history.",
    feature3Title: "Standardized Certificate",
    feature3Desc: "Generate professional reports with classification, components, and genesis. High-res export for sharing.",
    errorTitle: "Analysis Failed",
    errorGeneric: "Service temporarily unavailable, please try again later.",
    heicError: "HEIC conversion failed. Please use JPG or PNG.",
    saveTipTitle: "How to save?",
    saveTipDesc: "Due to system limits, please long-press the image below and select 'Save Image' or 'Send to Friend'.",
    copyImage: "Copy Image",
    copied: "Copied",
    downloadFile: "Download",
    thinTag: "Thin Section",
    potentialTag: "Potential",
    multiUploadTitle: "Multi-Image Analysis",
    multiUploadDesc: "Upload PPL/XPL (Thin Section) or Macro/Micro (Hand Specimen) for higher accuracy.",
    addMore: "Add More Images",
    analyzeNow: "Analyze Now",
    pplLabel: "PPL",
    xplLabel: "XPL",
    macroLabel: "Macro View",
    microLabel: "Micro Detail",
    imageCount: "images",
    guideTitle: "Expert Tips",
    guideHand: "📸 Hand Specimen: Upload a 'Macro View' and a 'Micro Detail' for macro-micro mapping.",
    guideThin: "🔬 Thin Section: Upload 'PPL' and 'XPL' of the same view to trigger Petrography Detective mode.",
    expertFeedback: "Expert Correction",
    feedbackTitle: "Submit Expert Correction",
    feedbackCorrectName: "Correct Rock Name",
    feedbackReason: "Reason (e.g., observed feature X instead of Y)",
    feedbackSubmit: "Submit",
    feedbackSuccess: "Thank you! We will use this to calibrate our knowledge base.",
    distillTitle: "Case Distiller",
    distillDesc: "Transform field findings into standardized Case Rules.",
    distillPrompt: "Please distill a core identification rule from this case...",
    limitReached: "Credits Exhausted",
    limitReachedSub: "Please get an activation code to continue using Stone Master.",
    upgradePro: "Get Credits",
    remainingTries: "Free tries remaining today",
    unlimited: "Unlimited",
    proActive: "Pro Active",
    enterCode: "Enter Activation Code",
    redeem: "Redeem",
    redeemSuccess: "Activation successful! Credits updated.",
    invalidCode: "Invalid code, please try again.",
    buyPro: "Scan to pay 30 RMB for 100 credits",
    orderRemark: "Please check your Alipay messages for the activation code after payment",
    contactSupport: "Contact Support for Code",
    creditsRemaining: "Credits remaining",
    confidence: "Confidence",
    diagnosticTitle: "Interactive Diagnostic Panel",
    diagnosticSub: "To improve accuracy, please perform the following physical tests and provide feedback.",
    testResult: "Test Result Feedback",
    diagnosticReady: "Diagnostic data ready for recalibration",
    diagnosticPending: "Please complete all suggested physical tests",
    submitDiagnostic: "Submit Results & Recalibrate",
    macroAppearance: "Macro Appearance",
    macroStructure: "Macro Structure",
    fossilTitle: "Fossil Archive",
    fossilType: "Fossil Type",
    genusSpecies: "Genus & Species",
    geologicalAge: "Geological Age",
    preservation: "Preservation",
    environment: "Environment",
    fossilDesc: "Fossil Description"
  }
};
